import { jsx as _jsx } from "react/jsx-runtime";
import { lazy, Suspense, useEffect, useRef, useState } from 'react';
import { useSettingsModalStore } from '@/stores/settingsModal';
import { shouldTrackSettingsModalOpen } from './helper';
const SettingsModalContent = /*#__PURE__*/ lazy(()=>import('./modal').then((module)=>({
            default: module.SettingsModalContent
        })));
export function SettingsModal() {
    const visible = useSettingsModalStore((state)=>state.visible);
    const type = useSettingsModalStore((state)=>state.type);
    const activeTab = useSettingsModalStore((state)=>state.activeTab);
    const source = useSettingsModalStore((state)=>state.source);
    const previousVisibleRef = useRef(false);
    const [hasOpened, setHasOpened] = useState(false);
    useEffect(()=>{
        const shouldTrack = shouldTrackSettingsModalOpen(previousVisibleRef.current, visible);
        if (shouldTrack) {
            collect('settings_modal_open', {
                source: source || 'unknown',
                tab: activeTab,
                type
            });
        }
        previousVisibleRef.current = visible;
    }, [
        activeTab,
        source,
        type,
        visible
    ]);
    useEffect(()=>{
        if (!visible) {
            return;
        }
        const currentState = useSettingsModalStore.getState();
        collect('settings_tab_view', {
            source: currentState.source || 'unknown',
            tab: activeTab.toLowerCase(),
            modal_type: currentState.type
        });
    }, [
        activeTab,
        visible
    ]);
    useEffect(()=>{
        if (visible) {
            setHasOpened(true);
        }
    }, [
        visible
    ]);
    if (!visible && !hasOpened) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Suspense, {
        fallback: null,
        children: /*#__PURE__*/ _jsx(SettingsModalContent, {})
    });
}
